import {Icon, Tag, Tooltip} from '@/components/atoms'
import {splitUtcToLocalDate} from '@/helpers/dateUtils'
import {TAG_COLOR} from '@/utils/constants/colors'
import {ROUTES} from '@/utils/constants/routesConstants'
import {useMemo} from 'react'
import {useNavigate} from 'react-router-dom'

const columnRenderers = (navigate, handleCopyClick) => ({
  name: {
    isClickable: true,
    onCellClick: (value, row) => {
      if (value && row?.id) {
        navigate(ROUTES.PROMOTION_DETAIL.replace(':id', row.id))
      }
    },
  },
  noOfStores: {
    renderCell: value => (value === null ? '-' : value),
  },
  percentPromotionAccepted: {
    renderCell: (value, row) => {
      const percentage = row?.percentagePromotionAccepted
      if (percentage === null) return '-'
      if (typeof percentage === 'number' && percentage < 90) {
        return <Tag text={`${percentage}%`} color={TAG_COLOR.RED_600} />
      }
      return `${percentage}%`
    },
  },
  activeStartDate: {
    renderCell: value => splitUtcToLocalDate(value),
  },
  activeEndDate: {
    renderCell: value => splitUtcToLocalDate(value),
  },
  status: {
    renderCell: (value, row) => {
      const status = value?.[0] + value?.slice(1).toLocaleLowerCase()
      return (
        <div className="data-table-icon">
          <span>{status}</span>
          <Tooltip direction="left" text="Duplicate">
            <button
              className="cursor-pointer"
              onClick={() => handleCopyClick(row?.id, row?.promotionType)}
              title="Duplicate"
            >
              <Icon className="cursor-pointer !text-[#0268d7]" icon="content_copy" size="big" />
            </button>
          </Tooltip>
        </div>
      )
    },
  },
})

export const usePromotionColumns = (colConfig, handleCopyClick) => {
  const navigate = useNavigate()

  return useMemo(() => {
    if (!colConfig?.length) return []

    const renderers = columnRenderers(navigate, handleCopyClick)

    return colConfig.map(col => ({
      name_of_db_column: col.name_of_db_column,
      label_of_column: col.columnFilterPlaceholder,
      filterVariant: col.filterVariant || 'text',
      ...renderers[col.name_of_db_column],
    }))
  }, [colConfig, navigate, handleCopyClick])
}
